import PlainSpinBoxMixin from 'elix/src/plain/PlainSpinBoxMixin.js';
import NumberSpinBox from '../base/NumberSpinBox.js';

/**
 * @class PlainNumberSpinBox
 */
class PlainNumberSpinBox extends PlainSpinBoxMixin(NumberSpinBox) {}

export default PlainNumberSpinBox;
